import {
  useController,
  UseControllerProps,
  useFormContext,
} from "react-hook-form";
import { SCode } from "messages/codes";
import { SSelect, SSelectProps } from "components/parts";
import { msgState } from "components";
import { useSetRecoilState } from "recoil";
import { getFormError } from "messages";

/**
 * コードセレクトボックス
 */

// TODO: プルダウンが他のコンポーネントの下に入らないようにz-indexを調整する。

/**
 * プロパティ
 */
type Props = Pick<UseControllerProps, "name" | "rules"> & {
  options: SCode[];
} & Partial<{
    empty: boolean;
  }> &
  Pick<
    SSelectProps,
    | "focusId"
    | "label"
    | "required"
    | "index"
    | "gridColumn"
    | "gridRow"
    | "disabled"
    | "onBlur"
    | "onChange"
    | "onKeyDown"
  >;

/**
 * コードセレクトボックス
 *
 * @param name: フィールド名
 * @param rules: react-hook-formのルールを設定(必須はrequiredで指定する)
 * @param options: コード配列を指定する
 * @param empty: 空値を許可する
 * @param label: エラーメッセージ用のラベル
 * @param required: 必須
 * @param index: フォーカス番号(1～)
 * @param gridColumn: CSSグリッドの列位置を指定する
 * @param gridRow: CSSグリッドの行位置を指定する
 * @param disabled: 非活性
 * @returns JSX.Element
 */

export const SValueSelect = ({
  name,
  rules,
  options,
  empty,
  label,
  required,
  ...props
}: Props): JSX.Element => {
  // フォーム設定
  const { control, trigger } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      ...rules,
      required: required && {
        value: required,
        message: getFormError("required", label ?? ""),
      },
    },
  });

  // エラーメッセージ設定
  const setMsg = useSetRecoilState(msgState);

  return (
    <SSelect
      {...props}
      name={field.name}
      value={field.value}
      options={options}
      formRef={field.ref}
      error={fieldState.invalid}
      onBlur={(event) => {
        trigger(name);
        props.onBlur?.call(this, event);
        setMsg(fieldState.error?.message || "");
      }}
      onChange={(newValue, actionMeta) => {
        field.onChange(newValue, actionMeta);
        props.onChange?.call(this, newValue, actionMeta);
      }}
      isDisabled={props.disabled}
      getOptionLabel={(option) => {
        const item = option as SCode;
        return `${item?.value}`;
      }}
      isClearable={empty}
    />
  );
};
